// controllers
import PageController from '../../../assets/js/controller/page';

// helpers
import { bindEvents, mq } from '../../../assets/js/helpers';

const selector = 'navigation-primary';

export default class NavigationPrimary {

	constructor(section) {

		// module elements
		this.el = {
			section,
			navItems: section.querySelectorAll('.cta--nav'),
			navItemsWrapper: section.querySelector('nav')
		};

		// global elements
		this.elGlobal = {
			header: section.closest('header'),
			page: document.body.querySelector('[data-body]')
		};

		// config options
		this.options = {
			truncateGutter: 90
		};

		// class variable groups

		this.controllers = {
			page: null
		};

		// boolean flags
		this.flags = {
			isEnabled: false
		};

		// bind events to class scope
		this.events = bindEvents(this);

		// engage
		this.init();
	}

	static get selector() {
		return selector;
	}

	// initialize class

	init() {
		this.addEventListeners();
	}

	// event listeners

	addEventListeners() {
		if (mq('medium')) {
			this.enable();
		} else {
			this.disable();
		}
	}

	removeEventListeners() {
		this.disable();
	}

	// listener methods

	// page update / render

	_onPageUpdate() {
		return true;
	}

	_onPageRender(e) {
		this.updateActiveNavItem(e.active.type, e.active.slug);
	}

	updateActiveNavItem(type, slug) {
		const $target = this.el.section.querySelector(`.cta--nav[href='/${slug}'], .cta--nav[data-type='${type}']`);
		const $activeItem = this.el.section.querySelector('.is-active');

		if ($activeItem) {
			$activeItem.classList.remove('is-active');
		}

		if ($target) {
			$target.classList.add('is-active');
		}
	}

	// enable / disable

	enable() {
		if (!this.isEnabled) {
			this.isEnabled = true;

			this.controllers.page = PageController.set({
				update: this.events._onPageUpdate,
				render: this.events._onPageRender
			});

			const { active } = PageController.status;
			this.updateActiveNavItem(active.type, active.slug);
		}
	}

	disable() {
		if (this.isEnabled) {
			this.isEnabled = false;
			PageController.clear(this.controllers.page);
		}
	}

	// destroy

	destroy() {
		this.removeEventListeners();
	}

}
